import * as yup from 'yup';

export const validationSchema = yup.object({
	email: yup.string().required('You must provide an username or email'),
	password: yup.string().required('Password is required'),
});
